import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import ComboText from '../../../components/ComboText';
import { ESPECIALIDADITEMS } from '../../../utils/ConstantsMain';
import {
    TextField,
    IconButton,
    InputAdornment,
    Grid,
    Button,
    FormControlLabel,
    Radio,
    FormLabel,
    FormControl,
    RadioGroup,
    FormHelperText,
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons'
import ButtonBase from '../../../components/Buttons/ButtonBase';
import './AddLawyer.scss'

const useStyles = makeStyles({
    textField: {
        maxWidth: 256,
        margin: '0 24px 40px 0',
        height: 48,
        padding: 0,
    },
    linkStyle: {
        display: 'flex',
        justifyContent: 'center',
        margin: '0 24px 0 0'
    },
    buttonStyle: {
        minWidth: 280,
    },
    colorGrayIcon: {
        color: '#c1c1c1',
        padding: 0
    },
    cancel: {
        width: 160,
        height: 40,
        borderRadius: 20,
        backgroundColor: 'white',
        color: '#013957',
        border: '1px solid #013957',
        fontSize: 16,
        fontWeight: 'bold',
        textTransform: 'inherit',
    },
    select: {
        minWidth: 256,
        '& .MuiInputLabel-marginDense': {
            transform: 'translate(14px, 16px) scale(1) !important',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            right: 22,
            bottom: 0,
        },
        '& .MuiInputLabel-shrink': {
            transform: 'translate(14px, -6px) scale(0.75) !important',
            zIndex: 10,
            right: 'unset',
            backgroundColor: '#fff',
            height: 'fit-content',
        },
    },
    rootFormControl: {
        display: 'flex',
        alignItems: 'center',
    },
    formControl: {
        maxWidth: 'initial'
    },
    formLabel: {
        color: '#484848',
        margin: '0 10px 0 0',
        fontWeight: 'bold',
    },
    formControlLabel: {
        margin: '0 16px 0 0',
    },
    formControlLabelUnselected: {
        margin: '0 16px 0 0',
        opacity: 0.4,
    },
})

const AddLawyerForm = (props) => {

    const {
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        touched,
        errors,
        isValid,
        setFieldValue,
        isModal,
        handleClose,
        handleOpenFilter,
        handleShowAddLawyer,
    } = props;

    const classes = useStyles()

    const [valuesPass, setValuesPass] = useState({
        password: '',
        showPassword: false,
    });

    const handleTagSelect = field => value => {
        setFieldValue(field, value);
    };

    const handleClickShowPassword = () => {
        setValuesPass({
            ...valuesPass,
            showPassword: !valuesPass.showPassword
        });
    };

    const handleChangeMultiple = field => event => {
        event.preventDefault();
        let value = event.target.value;
        setFieldValue(field, value);
    };

    const onCancel = () => {
        if (!isModal) {
            handleOpenFilter()
        }
        handleShowAddLawyer(false)
        if (handleClose) {
            handleClose()
        }
    }

    return (
        <form className={isModal ? 'addLawyerFormModal' : 'addLawyerForm'}>
            <FormControl
                error={touched.gender && errors.gender ? true : false}
                component="fieldset"
                className={classes.formControl}
            >
                <div className={classes.rootFormControl}>
                    <FormLabel
                        component="legend"
                        className={classes.formLabel}
                    >
                        Género*
                    </FormLabel>
                    <RadioGroup
                        row
                        aria-label="gender"
                        name="gender"
                        value={values.gender ? values.gender : null}
                        onChange={handleChangeMultiple('gender')}
                        onBlur={handleBlur}
                    >
                    <FormControlLabel
                        value="male"
                        control={<Radio color="secondary" />}
                        label="Masculino"
                        className={
                            values.gender && values.gender === 'female' ?
                            classes.formControlLabelUnselected :
                            classes.formControlLabel
                        }
                    />
                    <FormControlLabel
                        value="female"
                        className={
                            values.gender && values.gender === 'male' ?
                            classes.formControlLabelUnselected :
                            classes.formControlLabel
                        }
                        control={<Radio color="secondary" />}
                        label="Femenino"
                    />
                    </RadioGroup>
                </div>
                {touched.gender && errors.gender ? (
                    <FormHelperText
                        color="error"
                        classes={{ root: classes.formHelperText }}
                    >
                        {errors.gender}
                    </FormHelperText>
                ) : (
                    ''
                )}
            </FormControl>

            <Grid
                container
                direction="row"
            >
                <TextField
                    label="Nombre*"
                    id="name"
                    type="text"
                    variant="outlined"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.name ? values.name : ''}
                    helperText={
                        touched.name && errors.name
                        ? errors.name
                        : ''
                    }
                    error={touched.name && errors.name ? true : false}
                    className={classes.textField}
                />

                <TextField
                    label="Apellido Paterno*"
                    id="firstLastName"
                    type="text"
                    variant="outlined"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.firstLastName ? values.firstLastName : ''}
                    helperText={
                        touched.firstLastName && errors.firstLastName
                        ? errors.firstLastName
                        : ''
                    }
                    error={touched.firstLastName && errors.firstLastName ? true : false}
                    className={classes.textField}
                />

                <TextField
                    label="Apellido materno*"
                    id="secondLastName"
                    type="text"
                    variant="outlined"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.secondLastName ? values.secondLastName : ''}
                    helperText={
                        touched.secondLastName && errors.secondLastName
                        ? errors.secondLastName
                        : ''
                    }
                    error={touched.secondLastName && errors.secondLastName ? true : false}
                    className={classes.textField}
                />

                <TextField
                    label="Número telefónico*"
                    id="phone"
                    type="text"
                    variant="outlined"
                    onBlur={handleBlur}
                    onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
                    inputProps={{ minLength: 10, maxLength: 10 }}
                    onChange={handleChange}
                    value={values.phone}
                    helperText={touched.phone && errors.phone ? errors.phone : ''}
                    error={touched.phone && errors.phone ? true : false}
                    fullWidth
                    className={classes.textField}
                />

                <TextField
                    label="Cédula profesional*"
                    id="professionalLicense"
                    type="text"
                    variant="outlined"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.professionalLicense}
                    helperText={touched.professionalLicense && errors.professionalLicense ? errors.professionalLicense : ''}
                    error={touched.professionalLicense && errors.professionalLicense ? true : false}
                    fullWidth
                    className={classes.textField}
                />

                <ComboText
                    labelText={'Áreas de práctica*'}
                    itemsCombo={ESPECIALIDADITEMS}
                    sizeField={classes.textField}
                    textFieldStyles={classes.select}
                    multiple={true}
                    handleChanges={handleTagSelect('specialties')}
                    errors={errors.specialties}
                    touched={touched.specialties}
                    handleBlur={handleBlur}
                    name={'specialties'}
                    valuesMul={values.specialties}
                    cierre={true}
                />

                <TextField
                    label="Correo electrónico*"
                    id="email"
                    type="text"
                    variant="outlined"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.email ? values.email : ''}
                    helperText={
                        touched.email && errors.email
                        ? errors.email
                        : ''
                    }
                    error={touched.email && errors.email ? true : false}
                    className={classes.textField}
                />

                <TextField
                    id="outlined-adornment-password"
                    variant="outlined"
                    type={valuesPass.showPassword ? 'text' : 'password'}
                    label="Contraseña*"
                    name='password'
                    className={classes.textField}
                    value={values.password ? values.password : ''}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    helperText={
                        touched.password && errors.password
                        ? errors.password
                        : ''
                    }
                    error={touched.password && errors.password ? true : false}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="Toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    classes={{
                                        root: classes.colorGrayIcon
                                    }}
                                >
                                    {valuesPass.showPassword ?
                                        <VisibilityOff /> :
                                        <Visibility />
                                    }
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
            </Grid>
 
            <Grid
                container
                direction="row"
            >
                <ButtonBase
                    type="submit"
                    onClick={handleSubmit}
                    variant="primary"
                    disabled={!isValid}
                    linkStyle={classes.linkStyle}
                    buttonStyle={classes.buttonStyle}
                >
                    Crear abogado
                </ButtonBase>

                <Button
                    type="button"
                    onClick={onCancel}
                    variant="outlined"
                    className={classes.cancel}
                >
                    Cancelar
                </Button>
            </Grid>
        </form>
    )
}

export default AddLawyerForm;
